export default "__VITE_ASSET__3fd908d0__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg13__"